import * as React from "react";
import { WidgetWrapper } from "uxp/components";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { extractTextProperties, TextProperty } from "../../../common/ui-props/TextProperty";

import './styles.scss';
import { VerticalAlignmentProperty } from "../../../common/ui-props/VerticalAlignmentProperty";
import ActionRenderComponent from "../../../common/components/ActionRenderComponent";
import { extractContextData, loadInitialData, replaceWithData } from "../../../../util";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";

const XPRProps: IUIPropertyDefinitionMap = {
    'container': ContainerProperty({
        background: {
            image: {
                image: '',
                position: 'center',
                size: 'cover'
            }
        },
        onClick: { type: 'open-url' }
    }),
    'containerVerticalAlignment': VerticalAlignmentProperty('start'),
    'title': TextProperty({
        text: '',
        color: '',
        size: '12px',
        align: 'left'
    }),
    'subTitle': TextProperty({
        text: '',
        color: '',
        size: '12px',
        align: 'left'
    })
}

const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    let uiProps = props?.uiProps || {};

    const [actionData, setActionData] = React.useState({ action: null, contextData: {} })
    
    let [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)
    
    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    // main container 
    let { styles, onClick } = extractContainerProperties(uiProps.container)
    if (!styles.backgroundImage) styles.backgroundImage = 'url("https://picsum.photos/id/113/600/600")'

    // titles container
    let containerVerticalAlignment = uiProps?.containerVerticalAlignment || "start";
    // titles
    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, 'My Main Text Goes here')
    let { text: subTitle, styles: subTitleStyles } = extractTextProperties(uiProps.subTitle, 'Subtitle goes here')

    styles = { ...styles, alignItems: containerVerticalAlignment };

    title = replaceWithData(title, contextData)
    subTitle = replaceWithData(subTitle, contextData)

    return <WidgetWrapper className="uxp-image-card-template">
        <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'container')}
            contextData={contextData}
        >
            <div className="image" onClick={() => { setActionData({ action: onClick || null, contextData: contextData }) }} style={styles}>
                <div className="title-area">
                    <SelectableItem
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'containerVerticalAlignment')}
                        contextData={contextData}
                    >
                        <div className="titles" style={{ backgroundColor: "transparent" }}>
                            <div className="title">

                                <SelectableItem
                                    designer={props.designer}
                                    props={selectUIProps(uiProps, XPRProps, 'title', 'containerVerticalAlignment')}
                                    contextData={contextData}
                                >
                                    <div className="text" style={titleStyles}>{title}</div>
                                </SelectableItem>
                            </div>
                            <div className="sub-title">

                                <SelectableItem
                                    designer={props.designer}
                                    props={selectUIProps(uiProps, XPRProps, 'subTitle', 'containerVerticalAlignment')}
                                    contextData={contextData}
                                >
                                    <div className="text" style={subTitleStyles}>{subTitle}</div>
                                </SelectableItem>
                            </div>
                        </div>
                    </SelectableItem>
                </div>
            </div>
        </SelectableItem>

        <ActionRenderComponent
            designer={props.designer}
            uxpContext={props.uxpContext}
            {...actionData}
            onClose={() => setActionData({ action: null, contextData: {} })}
            onReloadWidget={() => { }}
        />

    </WidgetWrapper>
}


registerCardTemplate({
    id: 'image-card2',
    name: "Image Card2",
    description: 'Display an image with a main label and sublabel. Useful for showing a visual indicator and some statistic or KPI.',
    template: XPR,
    icon: ['fas', 'image'],
    complexity: 'easy'
});